"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var store_1 = __importDefault(require("@src/store"));
var DomainAPI_1 = require("@src/api/DomainAPI");
var const_1 = require("@src/const");
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var OptionsVerticalIcon_1 = __importDefault(require("relements/build/esm/ui/icons/OptionsVerticalIcon"));
// Icons & Images
var call_svg_1 = __importDefault(require("@src/components/Icon/call.svg"));
var mic_on_svg_1 = __importDefault(require("@src/components/Icon/mic-on.svg"));
var mic_off_svg_1 = __importDefault(require("@src/components/Icon/mic-off.svg"));
var end_call_svg_1 = __importDefault(require("@src/components/Icon/end-call.svg"));
var end_call_hover_svg_1 = __importDefault(require("@src/components/Icon/end-call-hover.svg"));
var haptik_branding_svg_1 = __importDefault(require("@src/components/Icon/haptik-branding.svg"));
var BotActions_1 = require("@src/actions/BotActions");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var useVoiceBotCall_1 = __importDefault(require("./hooks/useVoiceBotCall"));
// Styled Components
var StyledComponents_1 = require("./StyledComponents");
var NUM_BARS = 5;
var MIN_HEIGHT = 30;
var MAX_HEIGHT = 140;
var MIN_RING = [1, 1, 1, 1];
var MAX_RING = [1.1, 1.2, 1.3, 1.4];
var MAX_RING_MOBILE = [1.05, 1.1, 1.15, 1.2];
var VoicePage = function () {
    var _a;
    var _b = react_1.useState(null), device = _b[0], setDevice = _b[1];
    var _c = react_1.useState(false), isAuthenticated = _c[0], setIsAuthenticated = _c[1];
    var _d = react_1.useState(''), brandName = _d[0], setBrandName = _d[1];
    var _e = react_1.useState(''), phoneNumber = _e[0], setPhoneNumber = _e[1];
    var _f = react_1.useState(null), incomingConnection = _f[0], setIncomingConnection = _f[1];
    var _g = react_1.useState(null), currentConnection = _g[0], setCurrentConnection = _g[1];
    var _h = react_1.useState(false), inCall = _h[0], setInCall = _h[1];
    var _j = react_1.useState(false), isTwilioLoaded = _j[0], setIsTwilioLoaded = _j[1];
    var _k = react_1.useState(false), active = _k[0], setActive = _k[1];
    var _l = react_1.useState(false), isConnecting = _l[0], setIsConnecting = _l[1];
    var _m = react_1.useState(false), isConnected = _m[0], setIsConnected = _m[1];
    var _o = react_1.useState(false), isEndCallHovered = _o[0], setIsEndCallHovered = _o[1];
    var _p = react_1.useState(false), isContextMenuClicked = _p[0], setIsContextMenuClicked = _p[1];
    var _q = react_1.useState(false), isMicHovered = _q[0], setIsMicHovered = _q[1];
    var _r = react_1.useState(false), isPrimarySpeaking = _r[0], setIsPrimarySpeaking = _r[1];
    var _s = react_1.useState(true), isLoading = _s[0], setIsLoading = _s[1];
    var _t = react_1.useState(Array(NUM_BARS).fill(MIN_HEIGHT)), heights = _t[0], setHeights = _t[1];
    var _u = react_1.useState(MIN_RING), ringScale = _u[0], setRingScale = _u[1];
    var _v = react_1.useState(''), socketUrl = _v[0], setSocketUrl = _v[1];
    var _w = react_1.useState([]), demoJsonData = _w[0], setDemoJsonData = _w[1];
    var _x = react_1.useState(null), selectedDemoBot = _x[0], setSelectedDemoBot = _x[1];
    var _y = react_1.useState(false), demoBotDropdownActive = _y[0], setDemoBotDropdownActive = _y[1];
    var _z = react_1.useState(''), requestIdToCopy = _z[0], setRequestIdToCopy = _z[1];
    var _0 = react_1.useState(false), shouldRenderDemoBotDropdown = _0[0], setShouldRenderDemoBotDropdown = _0[1];
    var _1 = react_1.useState(24000), sampleRate = _1[0], setSampleRate = _1[1];
    var dropdownRef = react_1.useRef(null);
    var mixPanelTracker = store_1["default"].getMixPanel();
    var queryString = window.location.hash.includes('?')
        ? window.location.hash.split('?')[1]
        : '';
    var queryParams = new URLSearchParams(queryString);
    var websiteDemoValue = queryParams.get('website-demo');
    var sourceParam = queryParams.get('source');
    var shouldHideHaptikBranding = sourceParam === 'mycallgenie';
    var isDemoPage = window.location.hash.includes('?demo=true') ||
        window.location.hash.includes('/demo') ||
        window.location.hash.includes('&demo=true');
    var isTwilioPage = window.location.hash.includes('?twilio=true') ||
        window.location.hash.includes('&twilio=true');
    var enableBackgroundNoise = window.location.hash.includes('?background-noise=true') ||
        window.location.hash.includes('&background-noise=true');
    var disableNoiseCancellation = window.location.hash.includes('?noise-cancellation=false') ||
        window.location.hash.includes('&noise-cancellation=false');
    var hashSplitArray = window.location.hash.split('/');
    var domainId = (_a = hashSplitArray[3]) === null || _a === void 0 ? void 0 : _a.split('?')[0];
    var domainFromWebsiteDemoValue = demoJsonData.find(function (domain) { return domain.domainId === websiteDemoValue; });
    var defaultDomain = demoJsonData === null || demoJsonData === void 0 ? void 0 : demoJsonData.find(function (domain) { return domain.isDefault; });
    var demoDomainId = domainFromWebsiteDemoValue
        ? websiteDemoValue
        : defaultDomain === null || defaultDomain === void 0 ? void 0 : defaultDomain.domainId;
    var selectedDemoDomainId = selectedDemoBot
        ? selectedDemoBot.domainId
        : demoDomainId;
    var demoBrandName = domainFromWebsiteDemoValue
        ? domainFromWebsiteDemoValue.botName
        : defaultDomain === null || defaultDomain === void 0 ? void 0 : defaultDomain.botName;
    var demoBot = domainFromWebsiteDemoValue || defaultDomain;
    var requestId = socketUrl
        ? new URL(socketUrl).searchParams.get('request_id')
        : '';
    var startAnimation = function () { return setActive(true); };
    var stopAnimation = function () {
        setActive(false);
        setHeights(Array(NUM_BARS).fill(MIN_HEIGHT));
        setRingScale([1, 1, 1, 1]);
    };
    var _2 = useVoiceBotCall_1["default"](socketUrl, startAnimation, stopAnimation, setIsPrimarySpeaking, enableBackgroundNoise, disableNoiseCancellation, sampleRate), isMuted = _2.isMuted, isCalling = _2.isCalling, isCallConnected = _2.isCallConnected, callDuration = _2.callDuration, startCall = _2.startCall, stopCall = _2.stopCall, toggleMute = _2.toggleMute;
    var isMobile = window.innerWidth <= 500;
    var fetchSocketUrl = function (domainId) {
        DomainAPI_1.getSocketUrl(domainId, false, 'haptik')
            .then(function (res) { return res.json(); })
            .then(function (data) {
            setIsLoading(false);
            setIsAuthenticated(true);
            setSocketUrl(data === null || data === void 0 ? void 0 : data.ws_url);
            setBrandName(websiteDemoValue ? demoBrandName : data === null || data === void 0 ? void 0 : data.domain_name);
            setSampleRate((data === null || data === void 0 ? void 0 : data.sample_rate) || 24000);
            if (!selectedDemoBot && websiteDemoValue)
                setSelectedDemoBot(demoBot);
        })["catch"](function (e) {
            console.error('error', e);
        });
    };
    var endCall = function () {
        stopCall();
        console.log('Call Ended with:', requestId);
        setIsEndCallHovered(false);
        setIsMicHovered(false);
        var payloadDomainId = websiteDemoValue ? selectedDemoDomainId : domainId;
        fetchSocketUrl(payloadDomainId);
    };
    var initiateCall = function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, outgoingConnection;
        return __generator(this, function (_a) {
            setRequestIdToCopy(requestId);
            if (!isTwilioPage) {
                startCall(socketUrl);
                console.log('Call Started with:', requestId);
                if (websiteDemoValue) {
                    mixPanelTracker.track({
                        event: const_1.MIX_PANEL.AI_AGENTS.VOICE_AGENTS.VOICE_DEMO_CALL_STARTED,
                        payload: {
                            agent_id: domainId,
                            agent_name: demoBrandName,
                        },
                    });
                }
            }
            else {
                params = {
                    To: phoneNumber,
                };
                if (device && !isConnected) {
                    outgoingConnection = device.connect(params);
                    setCurrentConnection(outgoingConnection);
                    outgoingConnection.on('ringing', function () {
                        console.log('Ringing...');
                        setIsConnecting(true);
                    });
                    outgoingConnection.on('volume', function (inputVolume, outputVolume) {
                        if (outputVolume > 0.05) {
                            startAnimation();
                        }
                        else {
                            stopAnimation();
                        }
                        if (inputVolume > 0.1) {
                            setIsPrimarySpeaking(true);
                        }
                        else {
                            setIsPrimarySpeaking(false);
                        }
                    });
                }
            }
            return [2 /*return*/];
        });
    }); };
    // Effect to check for Twilio loading
    react_1.useEffect(function () {
        var checkTwilio = function () {
            if (window.Twilio) {
                setIsTwilioLoaded(true);
            }
        };
        if (isTwilioPage)
            checkTwilio();
        if (isConnecting || isCalling || isCallConnected) {
            endCall();
        }
        var interval = setInterval(checkTwilio, 1000);
        if (!mixPanelTracker) {
            store_1["default"].setMixPanel({
                cas: 'NA',
                env: 'NA',
                username: 'NA',
                useremail: 'NA',
                is_self_serve_user: false,
            });
        }
        // Api call for Haptik Socket connection
        if (!isTwilioPage) {
            var payloadDomainId = websiteDemoValue
                ? selectedDemoDomainId
                : domainId;
            if (payloadDomainId) {
                setIsLoading(true);
                fetchSocketUrl(payloadDomainId);
            }
        }
        return function () { return clearInterval(interval); };
    }, [window.location.hash, selectedDemoBot, demoBot]);
    // Twilio initialization
    react_1.useEffect(function () {
        var _a, _b, _c;
        var newDevice;
        if (isTwilioLoaded && isTwilioPage) {
            var hashSplitArray_1 = window.location.hash.split('/');
            var domainId_1 = (_a = hashSplitArray_1[3]) === null || _a === void 0 ? void 0 : _a.split('?')[0];
            DomainAPI_1.getTwilioToken(((_c = (_b = CommonStore_1["default"].getMetaTags()) === null || _b === void 0 ? void 0 : _b.domain) === null || _c === void 0 ? void 0 : _c.id) || domainId_1, isDemoPage)
                .then(function (res) { return res.json(); })
                .then(function (data) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (data.not_authenticated) {
                        setIsAuthenticated(false);
                        setIsLoading(false);
                        if (phoneNumber)
                            setPhoneNumber('');
                        if (brandName)
                            setBrandName('');
                        return [2 /*return*/];
                    }
                    setIsAuthenticated(true);
                    setPhoneNumber(data === null || data === void 0 ? void 0 : data.phone_number);
                    setBrandName(data === null || data === void 0 ? void 0 : data.botname);
                    newDevice = new window.Twilio.Device(data.token, {
                        codecPreferences: ['opus', 'pcmu'],
                        fakeLocalDTMF: true,
                        enableRingingState: true,
                        debug: true,
                        audioConstraints: {
                            autoGainControl: true,
                            echoCancellation: true,
                            noiseSuppression: true,
                        },
                    });
                    console.log('Device created, registering presence...', newDevice);
                    console.log('Device created, registering presence...', newDevice.state);
                    setTimeout(function () {
                        console.log('Device State after timeout:', newDevice.state);
                    }, 5000);
                    newDevice.on('ready', function () {
                        console.log('Chat App Device is ready');
                        setIsLoading(false);
                    });
                    newDevice.on('registered', function () {
                        console.log('Chat App Device is ready for incoming calls');
                    });
                    newDevice.on('registering', function () {
                        console.log('Chat App Device is registering...');
                    });
                    newDevice.on('error', function (error) {
                        console.error('Device error:', error);
                        setIsConnecting(false);
                    });
                    newDevice.on('connect', function (connection) {
                        console.log('Connected', connection);
                        setIsConnecting(false);
                        setIsConnected(true);
                    });
                    newDevice.on('disconnect', function () {
                        console.log('🚨 Call Disconnected Before Answering');
                        setIsConnected(false);
                        setIncomingConnection(null);
                        setInCall(false);
                        setCurrentConnection(null);
                        setIsConnecting(false);
                    });
                    newDevice.on('cancel', function () {
                        console.log('Call canceled');
                        setIsConnecting(false);
                    });
                    newDevice.on('reject', function () {
                        console.log('Call rejected');
                        setIsConnecting(false);
                    });
                    newDevice.on('incoming', function (connection) {
                        var To = connection.parameters.To;
                        console.log('Incoming call for:', To, data);
                        setIncomingConnection(connection);
                        connection.on('disconnect', function () {
                            console.log('🚨 Call Disconnected Before Answering');
                            setIncomingConnection(null);
                            setInCall(false);
                        });
                        connection.on('cancel', function () {
                            console.log('❌ Call was canceled before being answered');
                            setIncomingConnection(null);
                            setInCall(false);
                        });
                    });
                    newDevice.on('disconnect', function () {
                        setIncomingConnection(null);
                        setCurrentConnection(null);
                        setIsConnected(false);
                    });
                    console.log({ newDevice: newDevice });
                    if (newDevice)
                        setDevice(newDevice);
                    return [2 /*return*/];
                });
            }); })["catch"](function (error) { return console.error('Error fetching token:', error); });
        }
        return function () {
            if (newDevice)
                newDevice.destroy();
            console.log('Device destroyed');
        };
    }, [isTwilioLoaded, window.location.hash]);
    // Bar animations
    react_1.useEffect(function () {
        var interval;
        if (active) {
            interval = setInterval(function () {
                var newHeights = Array.from({ length: NUM_BARS }, function () {
                    return Math.floor(Math.random() * (MAX_HEIGHT - MIN_HEIGHT)) + MIN_HEIGHT;
                });
                setHeights(newHeights);
            }, 100);
        }
        return function () { return clearInterval(interval); };
    }, [active]);
    // Ring animations
    react_1.useEffect(function () {
        var interval;
        if (active) {
            interval = setInterval(function () {
                setRingScale(isMobile ? MAX_RING_MOBILE : MAX_RING);
            }, 100);
        }
        return function () { return clearInterval(interval); };
    }, [active]);
    var notConnectedUI = isConnecting || (isCalling && !isCallConnected) ? (react_1["default"].createElement(text_1["default"], { color: "background", style: { fontSize: '36px', fontWeight: '500' } }, "Connecting...")) : (react_1["default"].createElement(call_svg_1["default"], null));
    var mutedState = isMicHovered ? react_1["default"].createElement(mic_on_svg_1["default"], null) : react_1["default"].createElement(mic_off_svg_1["default"], null);
    var handleTransitionEnd = function () {
        if (!demoBotDropdownActive) {
            setShouldRenderDemoBotDropdown(false);
        }
    };
    var closeDropdown = function () {
        setDemoBotDropdownActive(false);
        if (dropdownRef.current) {
            requestAnimationFrame(function () {
                dropdownRef.current.style.opacity = '0';
                dropdownRef.current.style.visibility = 'hidden';
            });
        }
    };
    react_1.useEffect(function () {
        if (websiteDemoValue && mixPanelTracker) {
            mixPanelTracker.track({
                event: const_1.MIX_PANEL.AI_AGENTS.VOICE_AGENTS.VOICE_DEMO_PAGE_VIEWED,
                payload: {
                    agent_id: domainId,
                    agent_name: demoBrandName,
                },
            });
        }
    }, [websiteDemoValue, mixPanelTracker]);
    react_1.useEffect(function () {
        if (demoBotDropdownActive)
            setShouldRenderDemoBotDropdown(true);
    }, [demoBotDropdownActive]);
    // Add opacity transition by directly manipulating style after mount
    react_1.useEffect(function () {
        if (shouldRenderDemoBotDropdown &&
            dropdownRef.current &&
            demoBotDropdownActive) {
            requestAnimationFrame(function () {
                dropdownRef.current.style.opacity = '1';
                dropdownRef.current.style.visibility = 'visible';
            });
        }
    }, [shouldRenderDemoBotDropdown, demoBotDropdownActive]);
    react_1.useEffect(function () {
        fetch('https://toolassets.haptikapi.com/voice-demo.json')
            .then(function (val) { return val.json(); })
            .then(function (value) { return setDemoJsonData(value || []); });
    }, []);
    var renderCenterUI = function () {
        return isAuthenticated ? (react_1["default"].createElement(StyledComponents_1.CallWrapper, { padding: "0", isConnecting: isConnecting, inCall: !!currentConnection },
            shouldHideHaptikBranding && (react_1["default"].createElement(box_1["default"], { padding: "0", style: {
                    textAlign: 'center',
                    marginTop: '56px',
                } },
                react_1["default"].createElement(text_1["default"], { style: {
                        fontSize: isMobile ? '16px' : '18px',
                        fontWeight: '500',
                        color: 'hsl(262, 83%, 58%)',
                    } }, "Click on the phone to test your CallGenie"))),
            react_1["default"].createElement(box_1["default"], { style: {
                    position: 'relative',
                    cursor: isConnected ? 'default' : 'pointer',
                    width: isMobile ? '100vw' : '400px',
                    height: '70%',
                    aspectRatio: '1',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'visible',
                }, onClick: initiateCall },
                react_1["default"].createElement(box_1["default"], { style: {
                        width: isMobile ? '100vw' : '400px',
                        height: '100%',
                        position: 'relative',
                        overflow: 'hidden',
                    } },
                    react_1["default"].createElement(StyledComponents_1.CenterImage, { src: "https://tools-cdn.s3.ap-south-1.amazonaws.com/platform/assets/voice_ui_center.png", alt: "Call Icon" })),
                react_1["default"].createElement(StyledComponents_1.Ring, { className: "ring ring1", isConnecting: isConnecting, ringScale: ringScale[0] }),
                react_1["default"].createElement(StyledComponents_1.Ring, { className: "ring ring2", isConnecting: isConnecting, ringScale: ringScale[1] }),
                react_1["default"].createElement(StyledComponents_1.Ring, { className: "ring ring3", isConnecting: isConnecting, ringScale: ringScale[2] }),
                react_1["default"].createElement(StyledComponents_1.Ring, { className: "ring ring4", isConnecting: isConnecting, ringScale: ringScale[3] }),
                react_1["default"].createElement(box_1["default"], { style: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                        zIndex: '10',
                        backgroundColor: 'transparent',
                    } }, isConnected || (isCalling && isCallConnected) ? (react_1["default"].createElement(StyledComponents_1.BarContainer, null, heights.map(function (height, index) { return (react_1["default"].createElement(StyledComponents_1.Bar, { key: index, height: height })); }))) : (notConnectedUI))),
            (currentConnection || isCallConnected) && (react_1["default"].createElement(StyledComponents_1.ControlBox, { isPrimarySpeaking: isPrimarySpeaking },
                react_1["default"].createElement(box_1["default"], { padding: "0", width: "70px", height: "70px", style: {
                        cursor: 'pointer',
                        display: 'inline-block',
                        boxShadow: isPrimarySpeaking
                            ? '0 0 20px 10px rgba(0, 62, 135, 0.9)'
                            : '0 0 20px 5px rgba(127, 215, 255, 0.3)',
                        transition: 'box-shadow 0.5s ease-in-out',
                        borderRadius: '50%',
                    }, onMouseEnter: function () { return setIsMicHovered(true); }, onMouseLeave: function () { return setIsMicHovered(false); }, onClick: function () {
                        if (!isTwilioPage) {
                            toggleMute();
                        }
                        if (currentConnection) {
                            var newMute = !currentConnection.isMuted();
                            currentConnection.mute(newMute);
                        }
                    } }, (currentConnection && currentConnection.isMuted()) || isMuted ? (mutedState) : (react_1["default"].createElement(mic_on_svg_1["default"], null))),
                react_1["default"].createElement(box_1["default"], { padding: "0", width: "70px", height: "70px", style: { cursor: 'pointer', display: 'inline-block' }, onMouseEnter: function () { return setIsEndCallHovered(true); }, onMouseLeave: function () { return setIsEndCallHovered(false); }, onClick: function () {
                        if (!isTwilioPage) {
                            endCall();
                            if (websiteDemoValue) {
                                mixPanelTracker.track({
                                    event: const_1.MIX_PANEL.AI_AGENTS.VOICE_AGENTS.VOICE_DEMO_CALL_ENDED,
                                    payload: {
                                        agent_id: domainId,
                                        agent_name: demoBrandName,
                                    },
                                });
                                mixPanelTracker.track({
                                    event: const_1.MIX_PANEL.AI_AGENTS.VOICE_AGENTS
                                        .VOICE_DEMO_CALL_DURATION_RECORDED,
                                    payload: {
                                        agent_id: domainId,
                                        agent_name: demoBrandName,
                                        value: callDuration,
                                    },
                                });
                            }
                        }
                        else
                            currentConnection === null || currentConnection === void 0 ? void 0 : currentConnection.disconnect();
                        stopAnimation();
                    } }, isEndCallHovered ? react_1["default"].createElement(end_call_hover_svg_1["default"], null) : react_1["default"].createElement(end_call_svg_1["default"], null)))))) : (react_1["default"].createElement(box_1["default"], { padding: "0", style: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                flexDirection: 'column',
                textAlign: 'center',
                backgroundColor: 'transparent',
            } },
            react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "background" }, "Access Denied"),
            react_1["default"].createElement(text_1["default"], { varaint: "body.md", color: "background" }, "You do not have permission to view this page. Please log in or use a valid access link.")));
    };
    return (react_1["default"].createElement(box_1["default"], { width: "100%", height: "100%", flexDirection: "column", padding: "0", style: {
            backgroundColor: shouldHideHaptikBranding ? '#FFFFFF' : '#003C82',
            boxSizing: 'border-box',
            backgroundImage: shouldHideHaptikBranding
                ? 'none'
                : 'linear-gradient(to right, #144c8e 1px, transparent 1px),' +
                    'linear-gradient(to bottom, #144c8e 1px, transparent 1px)',
            backgroundSize: '40px 40px',
        } },
        !shouldHideHaptikBranding && (react_1["default"].createElement(box_1["default"], { padding: isMobile ? '12px' : '20px 95px', height: "110px", justifyContent: "space-between", alignItems: "center", style: { boxSizing: 'border-box', backgroundColor: 'transparent' } },
            react_1["default"].createElement(box_1["default"], { padding: 0, maxWidth: isMobile && '35%' },
                react_1["default"].createElement(haptik_branding_svg_1["default"], null)),
            websiteDemoValue ? (react_1["default"].createElement(box_1["default"], { maxWidth: "50vw", width: "max-content", flexDirection: "column", style: { position: 'relative' } },
                selectedDemoBot && (react_1["default"].createElement(box_1["default"], { onClick: function () {
                        if (demoBotDropdownActive)
                            closeDropdown();
                        else {
                            setDemoBotDropdownActive(true);
                            if (websiteDemoValue) {
                                mixPanelTracker.track({
                                    event: const_1.MIX_PANEL.AI_AGENTS.VOICE_AGENTS
                                        .VOICE_DEMO_AGENT_DROPDOWN_OPENED,
                                    payload: {
                                        agent_id: domainId,
                                        agent_name: demoBrandName,
                                    },
                                });
                            }
                        }
                    }, style: { cursor: 'pointer' } }, !shouldHideHaptikBranding && (react_1["default"].createElement(react_1["default"].Fragment, null,
                    react_1["default"].createElement(text_1["default"], { color: "#FFFFFFB2", style: {
                            fontSize: isMobile ? '20px' : '22px',
                            fontWeight: '600',
                            wordWrap: 'break-word',
                        } }, (selectedDemoBot === null || selectedDemoBot === void 0 ? void 0 : selectedDemoBot.botName) || ''),
                    react_1["default"].createElement(StyledComponents_1.StyledIcon, { src: "angle-down", color: "#FFFFFFB2", active: demoBotDropdownActive }))))),
                react_1["default"].createElement(box_1["default"], { onClick: closeDropdown, style: {
                        display: demoBotDropdownActive ? 'block' : 'none',
                        position: 'fixed',
                        inset: 0,
                        zIndex: '2',
                    } }),
                shouldRenderDemoBotDropdown && (react_1["default"].createElement(box_1["default"], { padding: "0 24px", flexDirection: "column", width: "max-content", style: {
                        opacity: 0,
                        visibility: 'hidden',
                        transition: 'all 0.3s ease-in-out',
                        position: 'absolute',
                        top: '50px',
                        right: isMobile ? '0' : '0',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        borderRadius: '16px',
                        zIndex: '10',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        overflow: 'hidden',
                    }, ref: dropdownRef, onTransitionEnd: handleTransitionEnd }, demoJsonData.map(function (domain, index) {
                    var isSelectedBot = domain.botName === (selectedDemoBot === null || selectedDemoBot === void 0 ? void 0 : selectedDemoBot.botName);
                    return (react_1["default"].createElement(box_1["default"], { alignItems: "center", onClick: function (e) {
                            e.stopPropagation();
                            if (isSelectedBot)
                                return;
                            setSelectedDemoBot(domain);
                            if (websiteDemoValue) {
                                mixPanelTracker.track({
                                    event: const_1.MIX_PANEL.AI_AGENTS.VOICE_AGENTS
                                        .VOICE_DEMO_AGENT_CHANGED,
                                    payload: {
                                        agent_id: domainId,
                                        agent_name: demoBrandName,
                                        value: domain.domainId,
                                    },
                                });
                            }
                            setDemoBotDropdownActive(false);
                        }, padding: "16px 0", backgroundColor: "transparent", style: {
                            cursor: 'pointer',
                            borderBottom: index !== demoJsonData.length - 1 &&
                                '1px solid rgba(255,255,255,0.3)',
                            gap: '10px',
                        } },
                        react_1["default"].createElement("img", { src: domain.img, style: {
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                background: 'red',
                            } }),
                        react_1["default"].createElement(text_1["default"], { color: domain.botName === (selectedDemoBot === null || selectedDemoBot === void 0 ? void 0 : selectedDemoBot.botName)
                                ? '#99FFFF'
                                : '#FFF', style: {
                                fontSize: isMobile ? '16px' : '18px',
                                fontWeight: '500',
                                wordWrap: 'break-word',
                            } }, domain.botName)));
                }))))) : (react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "center", style: {
                    gap: '4px',
                    position: 'relative',
                    maxWidth: '50%',
                } },
                brandName && (react_1["default"].createElement(text_1["default"], { color: "#FFFFFFB2", style: {
                        fontSize: isMobile ? '20px' : '22px',
                        fontWeight: '600',
                        wordWrap: 'break-word',
                    } }, brandName)),
                requestIdToCopy && (react_1["default"].createElement(react_1["default"].Fragment, null,
                    react_1["default"].createElement(box_1["default"], { padding: "0", onClick: function () {
                            setIsContextMenuClicked(function (prev) { return !prev; });
                        }, style: { cursor: 'pointer' } },
                        react_1["default"].createElement(OptionsVerticalIcon_1["default"], { iconColor: "background" })),
                    isContextMenuClicked && (react_1["default"].createElement(box_1["default"], { backgroundColor: "#fff", style: {
                            position: 'absolute',
                            top: 40,
                            right: 0,
                            borderRadius: '4px',
                        } },
                        react_1["default"].createElement(text_1["default"], { style: { cursor: 'pointer' }, onClick: function () {
                                navigator.clipboard
                                    .writeText(requestIdToCopy)
                                    .then(function () {
                                    console.log('Copied:', requestIdToCopy);
                                    BotActions_1.createAlert('Copied Successfully', 1000, MogamboConstants_1.AlertTypes.POSITIVE);
                                })["catch"](function (err) {
                                    console.error('Copy failed:', err);
                                    BotActions_1.createAlert('Copy Failed!!', 1000, MogamboConstants_1.AlertTypes.POSITIVE);
                                });
                                setIsContextMenuClicked(false);
                            } }, "Copy Request Id"))))))))),
        isLoading ? (react_1["default"].createElement(StyledComponents_1.StyledLoader, { themed: true, size: "52", color: "#fff" })) : (renderCenterUI())));
};
exports["default"] = VoicePage;
